module.exports = "/_next/static/images/Folder-f2184d2bf4af19d3839ae70dc12cdac8.png";